import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { FBasicPropos } from "../../../interfaces/User.interface";
import { Controller } from "react-hook-form";

export const FSelectField: React.FC<FBasicPropos> = ({ field, control, errors, errorMessage }) => {
    const {inputProps, name, question, options} = field;
    const isDisabled = field.props?.disabled;
    if (!errorMessage) errorMessage = errors[name]?.message as string;

    return (
        <FormControl
            variant="outlined"
            margin="normal"
            fullWidth
            error={!!errors[name] || !!errorMessage}
        >
            <InputLabel>{question}</InputLabel>
            <Controller
                name={name}
                control={control}
                render={({ field: controllerField }) => (
                    <Select
                        {...controllerField}
                        label={question}
                        error={!!errors[name] || !!errorMessage}
                        inputProps={{ ...inputProps} }
                        // required={field.required}
                        value={controllerField.value ?? ''}
                        disabled={isDisabled}
                    >
                        {(options ?? []).map((option, index) => (
                            <MenuItem key={index} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                )}
            />
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
        </FormControl>
    );
};
